// Em ModalEditVehicle.tsx

import { Modal } from "flowbite-react";
import { Formik, Form } from "formik";
import ButtonWithLoader from "@/common/components/ui/loading/ButtonLoading";
import FormEditVehicle from "../forms/FormEditVehicle";
import {
  IVehicleTransfer,
  VEHICLE_TRANSFER_STATUS,
} from "@/types/vehicleTransfer.type";
import * as Yup from "yup";
import Loading from "@/common/components/ui/loading/Loading";
import { useToastContext } from "@/common/components/ui/toast/toast.context";
import { updateVehicleTransfer } from "@/common/services/vehiclesTransfer.api";

type Props = {
  onClose: () => void;
  onSave: () => void;
  transfer: IVehicleTransfer;
};
const validationSchema = Yup.object().shape({
  vehicles: Yup.array()
    .of(
      Yup.object().shape({
        licensePlate: Yup.string().required(),
      })
    )
    .min(1, "É necessário adicionar pelo menos um veículo à transferência."),
});

export default function ModalEditVehicle({ onClose, onSave, transfer }: Props) {
  const isCompleted = transfer.status === VEHICLE_TRANSFER_STATUS.COMPLETED;
  const { notifySuccess, notifyError } = useToastContext();

  async function handleSubmit(values, { setSubmitting }) {
    try {
      const result = await updateVehicleTransfer(transfer._id, {
        vehicles: values.vehicles,
      });

      if (result.ok) {
        notifySuccess(`Veículos atualizados na transferência!`);
        onSave();
      } else {
        notifyError(result.message || "Falha ao atualizar.");
      }
    } catch (err) {
      console.error(err);
      notifyError("Ocorreu um erro de rede. Tente novamente.");
    } finally {
      setSubmitting(false);
    }
  }
  if (!transfer) {
    return (
      <Modal show={true} onClose={onClose}>
        <Modal.Body>
          <Loading />
        </Modal.Body>
      </Modal>
    );
  }

  return (
    <Modal show={true} size="4xl" onClose={onClose}>
      <Modal.Header className="text-black">
        <h2 className="text-black">
          {isCompleted
            ? "Visualizar Veículos da Transferência"
            : "Adicionar Veículos à Transferência"}
        </h2>
      </Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={{
            vehicles: transfer.vehicles || [],
            newVehicleLicensePlate: "",
            newVehicleContent: "",
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form>
              <FormEditVehicle transfer={transfer} isReadOnly={isCompleted} />

              <div className="flex justify-end mt-8 border-t pt-4">
                <ButtonWithLoader
                  type={isCompleted ? "button" : "submit"}
                  onClick={isCompleted ? onClose : undefined}
                  isLoading={isSubmitting && !isCompleted}
                >
                  {isCompleted ? "Fechar" : "Salvar Alterações"}
                </ButtonWithLoader>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
}
